import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import TextField from "@mui/material/TextField";
import Fade from "react-reveal/Fade";

import { useForm } from "react-hook-form";
import CheckIcon from "@mui/icons-material/Check";
import Alert from "@mui/material/Alert";

import FormControl from "@mui/material/FormControl";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";

import { useAuth } from "../../../../context/AuthContext";
import { useStateContext } from "../../../../context/StateContext_KO";
import {
  functions,
  httpsCallable,
  addDoc,
  collection,
  db,
  getDocs,
} from "../../../../firebase";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import HelpIcon from "@mui/icons-material/Help";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import PriorityHighOutlinedIcon from "@mui/icons-material/PriorityHighOutlined";

const EnterAddress = (props) => {
  const { t, i18n } = useTranslation();
  const [error, setError] = useState("");
  const { getAddresses, currentUser } = useAuth();
  const [addressIndex, setAddressIndex] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [list, setList] = useState([]);
  const [presetshippingAddress, setpresetshippingAddress] = useState(null);
  const [allAddressesFromDB, setAllAddressesFromDB] = useState(
    getAddresses() || null
  );
  const { basket } = useStateContext();

  const [checked, setChecked] = React.useState(true);
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  // console.log(checked);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    console.log(props.shippingAddress);
    if (props.shippingAddress) {
      setpresetshippingAddress(props.shippingAddress);
      setValue("firstname", props.shippingAddress.firstname, {
        shouldValidate: true,
      });
      setValue("lastname", props.shippingAddress.lastname, {
        shouldValidate: true,
      });
      setValue("address", props.shippingAddress.address, {
        shouldValidate: true,
      });
      setValue("apt", props.shippingAddress.apt, {
        shouldValidate: true,
      });
      setValue("city", props.shippingAddress.city, {
        shouldValidate: true,
      });
      setValue("state", props.shippingAddress.state, {
        shouldValidate: true,
      });
      setValue("zipcode", props.shippingAddress.zipcode, {
        shouldValidate: true,
      });

      setShow_address(props.shippingAddress.address);
      setShow_state(props.shippingAddress.apt);
      setShow_Zipcode(props.shippingAddress.zipcode);
      setShow_city(props.shippingAddress.city);
    } else if (getAddresses().length > 0) {
      setValue("firstname", getAddresses()[addressIndex || 0].firstname, {
        shouldValidate: true,
      });
      setValue("lastname", getAddresses()[addressIndex || 0].lastname, {
        shouldValidate: true,
      });
      setValue("address", getAddresses()[addressIndex || 0].address, {
        shouldValidate: true,
      });
      setValue("apt", getAddresses()[addressIndex || 0].apt.replace("#", ""), {
        shouldValidate: true,
      });
      setValue("city", getAddresses()[addressIndex || 0].city, {
        shouldValidate: true,
      });
      setValue("state", getAddresses()[addressIndex || 0].state, {
        shouldValidate: true,
      });
      setValue("zipcode", getAddresses()[addressIndex || 0].zipcode, {
        shouldValidate: true,
      });
    }
  }, []);

  const changeAddressIndex = (index) => {
    setAddressIndex(index);
    if (getAddresses().length > 0) {
      setValue("firstname", getAddresses()[index || 0].firstname, {
        shouldValidate: true,
      });
      setValue("lastname", getAddresses()[index || 0].lastname, {
        shouldValidate: true,
      });
      setValue("address", getAddresses()[index || 0].address, {
        shouldValidate: true,
      });
      setValue("apt", getAddresses()[index || 0].apt, {
        shouldValidate: true,
      });
      setValue("city", getAddresses()[index || 0].city, {
        shouldValidate: true,
      });
      setValue("state", getAddresses()[index || 0].state, {
        shouldValidate: true,
      });
      setValue("zipcode", getAddresses()[index || 0].zipcode, {
        shouldValidate: true,
      });
    }

    setShow_address(getAddresses()[index || 0].address);
    setShow_state(getAddresses()[index || 0].state);
    setShow_Zipcode(getAddresses()[index || 0].zipcode);
    setShow_city(getAddresses()[index || 0].city);
  };

  const submit = async (data) => {
    setProcessing(true);

    const re = /[\u3131-\uD79D]/giu;
    if (data.city.match(re) === null || data.city.match(re) === null) {
      setProcessing(false);
      setError(
        t("Please put a korean address. This address is not valid in Korea.")
      );
    } else {
      // save the address to the checkout page
      props.setShippingAddress({
        firstname: data.firstname,
        lastname: data.lastname,
        address: data.address,
        apt: data.apt,
        city: data.city,
        state: data.state,
        zipcode: data.zipcode,
      });

      if (checked && currentUser) {
        try {
          const querySnapshot = await getDocs(
            collection(db, "users", currentUser.uid, "address")
          );
          let found = false;

          querySnapshot.forEach((doc) => {
            console.log(doc.data());
            if (doc.data()) {
              if (
                doc.data().firstname.trim().toUpperCase() ===
                  data.firstname.trim().toUpperCase() &&
                doc.data().lastname.trim().toUpperCase() ===
                  data.lastname.trim().toUpperCase() &&
                doc.data().address.trim().toUpperCase() ===
                  data.address.trim().toUpperCase() &&
                doc.data().apt.trim().toUpperCase() ===
                  data.apt.trim().toUpperCase() &&
                doc.data().city.trim().toUpperCase() ===
                  data.city.trim().toUpperCase() &&
                doc.data().state.trim().toUpperCase() ===
                  data.state.trim().toUpperCase() &&
                doc.data().zipcode.trim().toUpperCase() ===
                  data.zipcode.trim().toUpperCase()
              ) {
                found = true;
              }
            }
            console.log(doc.id, " => ", doc.data());
          });
          console.log("======> found", found);
          if (!found) {
            const docRef2 = await addDoc(
              collection(db, "users", currentUser.uid, "address"),
              {
                firstname: data.firstname,
                lastname: data.lastname,
                address: data.address,
                apt: data.apt,
                city: data.city,
                state: data.state,
                zipcode: data.zipcode,
              }
            );
            console.log(docRef2);
          }
        } catch (error) {
          console.log(error);
        }
      }

      props.goToNextStep();
      window.scrollTo(0, 0);
    }
  };

  const { daum } = window;

  const [show_address, setShow_address] = useState(null);
  const [show_state, setShow_state] = useState(null);
  const [show_zipcode, setShow_Zipcode] = useState(null);
  const [show_city, setShow_city] = useState(null);

  const createNew = () => {
    new daum.Postcode({
      oncomplete: function (data) {
        console.log(data);
        if (data.buildingName) {
          setValue("address", data.address + " (" + data.buildingName + ")", {
            shouldValidate: true,
          });
          setShow_address(data.address + " (" + data.buildingName + ")");
        } else {
          setValue("address", data.address, {
            shouldValidate: true,
          });
          setShow_address(data.query);
        }
        setValue("state", data.sido, {
          shouldValidate: true,
        });
        setShow_state(data.sido);
        setValue("zipcode", data.zonecode, {
          shouldValidate: true,
        });
        setShow_Zipcode(data.zonecode);
        setValue("city", data.sigungu, {
          shouldValidate: true,
        });
        setShow_city(data.sigungu);
      },
    }).open();
  };

  return (
    <Box sx={{ pt: 7, px: 7, pb: 10 }}>
      <Fade delay={300}>
        <Box
          sx={{
            display: "flex",
            width: 1,
            borderBottom: "1px solid lightgray",
            paddingBottom: "10px",
          }}
        >
          <Box sx={{ pr: 4 }}>{t("email")}</Box>
          <Box>{props.email}</Box>
          <Box
            sx={{
              fontSize: "14px",
              color: "gray",
              marginLeft: "auto",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => props.goToFirstStep()}
          >
            {t("edit")}
          </Box>
        </Box>

        <Box sx={{ pt: 6 }}>
          <Box sx={{ pb: 2, fontSize: "16px", fontWeight: 600 }}>
            {t("Your Shipping Address")}
          </Box>
          <Box>
            {currentUser && (
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={handleChange}
                      defaultChecked
                    />
                  }
                  label={t("Save this address on my profile")}
                />
              </FormGroup>
            )}
          </Box>
          <Box sx={{ py: 2 }}>
            <button className="custom_btn" onClick={createNew}>
              {t("Search Address")}{" "}
              <CheckOutlinedIcon
                sx={{ fontSize: "13px", color: "lightblue" }}
              />
            </button>
          </Box>
          <Box sx={{ pl: 1, pb: 2 }}>
            <PriorityHighOutlinedIcon
              sx={{ position: "relative", top: "+6px" }}
            />
            <span className="pink_link">
              {t("Search your address by clicking the button above.")}
            </span>
          </Box>
          <Box>{error && <Alert severity="error">{error}</Alert>}</Box>

          <Box sx={{ pb: 1 }}>
            {errors.firstname && (
              <Alert severity="warning" sx={{ my: 2 }}>
                {errors.firstname?.message}
              </Alert>
            )}
            {!errors.firstname && errors.lastname && (
              <Alert severity="warning">{errors.lastname?.message}</Alert>
            )}
            {!errors.firstname && !errors.lastname && errors.address && (
              <Alert severity="warning">{errors.address?.message}</Alert>
            )}
            {!errors.firstname &&
              !errors.lastname &&
              !errors.address &&
              errors.city && (
                <Alert severity="warning">{errors.city?.message}</Alert>
              )}
            {!errors.firstname &&
              !errors.lastname &&
              !errors.address &&
              !errors.city &&
              errors.state && (
                <Alert severity="warning">{errors.state?.message}</Alert>
              )}
            {!errors.firstname &&
              !errors.lastname &&
              !errors.address &&
              !errors.city &&
              !errors.state &&
              errors.zipcode && (
                <Alert severity="warning">{errors.zipcode?.message}</Alert>
              )}
          </Box>
          {!processing ? (
            <form
              autocomplete="off"
              onSubmit={handleSubmit((data) => {
                submit(data);
              })}
            >
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    display: "flex",
                    minWidth: "200px",
                    alignItems: "center",
                  }}
                >
                  {t("ln") + "*"}
                </Box>
                <TextField
                  fullWidth
                  variant="filled"
                  autoComplete="family-name"
                  sx={{ width: 1, mb: 2 }}
                  {...register("lastname", {
                    required: "Last name is required.",
                    minLength: {
                      value: 1,
                      message: "Last Name's minimum length is 1.",
                    },
                  })}
                />
              </Box>
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    display: "flex",
                    minWidth: "200px",
                    alignItems: "center",
                  }}
                >
                  {t("fn") + "*"}
                </Box>
                <TextField
                  autoComplete="given-name"
                  variant="filled"
                  fullWidth
                  autoFocus
                  {...register("firstname", {
                    required: t("First name is required."),
                    minLength: {
                      value: 1,
                      message: t("First Name's minimum length is 1."),
                    },
                  })}
                />
              </Box>

              <Box sx={{ display: "flex", mt: 4 }}>
                <Box
                  sx={{
                    display: "flex",
                    minWidth: "200px",
                    alignItems: "center",
                  }}
                >
                  {t("ck_address") + "*"}
                  <Tooltip
                    title={t(
                      "Please search your adress with the 'search address' button"
                    )}
                  >
                    <IconButton>
                      <HelpIcon
                        sx={{
                          fontSize: "13px",
                          position: "relative",
                          top: "-6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    borderBottom: "1px solid black",
                    width: 1,
                    backgroundColor: "#f0f0f0",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                  }}
                >
                  {show_address}
                </Box>
                <TextField
                  id="outlined-basic"
                  variant="filled"
                  sx={{
                    width: 1,
                    mt: 2,
                    pointerEvents: "none",
                    display: "none",
                  }}
                  {...register("address", {
                    required: "Address is required.",
                    autoComplete: "off",
                  })}
                />
              </Box>

              <Box sx={{ display: "flex", mt: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    minWidth: "200px",
                    alignItems: "center",
                    position: "relative",
                    top: "+9px",
                  }}
                >
                  {t("Apt")}
                </Box>
                <TextField
                  id="outlined-basic"
                  variant="filled"
                  sx={{ width: 1, mt: 2 }}
                  {...register("apt")}
                />
              </Box>

              <Box sx={{ display: "flex", mt: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    minWidth: "200px",
                    alignItems: "center",
                  }}
                >
                  {t("City") + "*"}
                  <Tooltip
                    title={t(
                      "Please search your adress with the 'search address' button"
                    )}
                  >
                    <IconButton>
                      <HelpIcon
                        sx={{
                          fontSize: "13px",
                          position: "relative",
                          top: "-6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    borderBottom: "1px solid black",
                    width: 1,
                    backgroundColor: "#f0f0f0",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                  }}
                >
                  {show_city}
                </Box>
                <TextField
                  id="outlined-basic"
                  variant="filled"
                  sx={{
                    width: 1,
                    mt: 2,
                    pointerEvents: "none",
                    display: "none",
                  }}
                  {...register("city", {
                    required: "City is required.",
                    autoComplete: "off",
                  })}
                />
              </Box>

              <Box sx={{ display: "flex", mt: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    minWidth: "200px",
                    alignItems: "center",
                  }}
                >
                  {t("State") + "*"}
                  <Tooltip
                    title={t(
                      "Please search your adress with the 'search address' button"
                    )}
                  >
                    <IconButton>
                      <HelpIcon
                        sx={{
                          fontSize: "13px",
                          position: "relative",
                          top: "-6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    borderBottom: "1px solid black",
                    width: 1,
                    backgroundColor: "#f0f0f0",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                  }}
                >
                  {show_state}
                </Box>
                <TextField
                  id="outlined-basic"
                  variant="filled"
                  sx={{
                    width: 1,
                    mt: 2,
                    pointerEvents: "none",
                    display: "none",
                  }}
                  {...register("state", {
                    required: "This is required.",
                    autoComplete: "off",
                  })}
                />
              </Box>

              <Box sx={{ display: "flex", mt: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    minWidth: "200px",
                    alignItems: "center",
                  }}
                >
                  {t("Zipcode") + "*"}
                  <Tooltip
                    title={t(
                      "Please search your adress with the 'search address' button"
                    )}
                  >
                    <IconButton>
                      <HelpIcon
                        sx={{
                          fontSize: "13px",
                          position: "relative",
                          top: "-6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    borderBottom: "1px solid black",
                    width: 1,
                    backgroundColor: "#f0f0f0",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                  }}
                >
                  {show_zipcode}
                </Box>
                <TextField
                  id="outlined-basic"
                  variant="filled"
                  sx={{
                    width: 1,
                    mt: 2,
                    pointerEvents: "none",
                    display: "none",
                  }}
                  {...register("zipcode", {
                    required: "Zipcode is required.",
                    autoComplete: "off",
                  })}
                />
              </Box>

              <button
                type="submit"
                disabled={processing}
                className="custom_btn"
                style={{ marginTop: "20px" }}
                role="link"
              >
                {processing ? "...Processing" : t("Go To Payment")}
              </button>
            </form>
          ) : (
            <Box
              sx={{
                width: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100px",
                color: "#f3756d",
              }}
            >
              <CircularProgress />
              &nbsp;&nbsp;
              <Box className="">Validating your address</Box>
            </Box>
          )}
        </Box>
      </Fade>

      <Box sx={{ pt: 5 }}>{t("Change the shipping address to")}</Box>
      {allAddressesFromDB.map((anObjectMapped, index) => {
        return (
          <Box
            key={`${anObjectMapped.address}`}
            onClick={() => changeAddressIndex(index)}
            sx={{
              p: 3,
              border: "1px solid black",
              mt: 3,
              cursor: "pointer",
              "&:hover": { background: "#eceff1" },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "10px",
                  backgroundColor: "#bc5b4b",
                  mr: 2,
                  position: "relative",
                  top: "-2px",
                }}
              ></Box>
              {anObjectMapped.lastname} {anObjectMapped.firstname}
            </Box>
            <Box>
              {anObjectMapped.address} {anObjectMapped.apt}{" "}
              {anObjectMapped.city} {anObjectMapped.state}{" "}
              {anObjectMapped.zipcode}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default EnterAddress;
